import { supabase } from "./supabaseClient";

const API = (process.env.REACT_APP_API ?? "").trim();

function joinUrl(base: string, path: string) {
  if (!base) return path;
  if (path.startsWith("http")) return path;
  return base.replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const url = joinUrl(API, path);

  const { data, error } = await supabase.auth.getSession();
  const token = data?.session?.access_token ?? "";

  console.log("[apiFetch] URL =", url, "API =", API, "token?", !!token);
  if (error) throw error;
  if (!API) throw new Error("REACT_APP_API is empty. Check .env.local");
  if (!token) throw new Error("Not signed in (no Supabase access token)");

  const headers = new Headers(init.headers || {});
  if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
  if (!headers.has("Content-Type") && init.body) headers.set("Content-Type", "application/json");

  const res = await fetch(url, { ...init, headers, credentials: "omit" });
  console.log("[apiFetch] status", res.status);
  return res;
}
